import ErrorBoundary from '~/components/ErrorBoundary'
import { useAPPTranslation } from '~/i18n/useAPPTranslation'

import FormByStrategy from './strategies'
import { withCampaignFormProvider } from './withCampaignFormProvider'

/** Form shell without provider — compose with `withCampaignFormProvider` when needed. */
export const CampaignForm = () => {
  const { t } = useAPPTranslation()

  return (
    <ErrorBoundary
      name="CampaignForm"
      errorComponentProps={{
        title: t('c:components.ErrorBoundary.title'),
        description: t('c:components.ErrorBoundary.description'),
        tryAgainLabel: t('c:components.ErrorBoundary.tryAgainLabel'),
        errorLabel: t('c:components.ErrorBoundary.errorLabel'),
        fullScreen: false
      }}
    >
      <FormByStrategy />
    </ErrorBoundary>
  )
}

export const CampaignFormWithProvider = withCampaignFormProvider(CampaignForm)

export default CampaignFormWithProvider
// Sonar prefers `export…from` for re-exports; keep local import for composition above.
// eslint-disable-next-line no-duplicate-imports
export { withCampaignFormProvider } from './withCampaignFormProvider'
export { CampaignFormProvider } from './hooks/useCampaignForm'
